import dashboards from './../dashboards'
import userAccount from './../user-account'
import parking from './../parking'
import administration from './../administration'
import reservation from './../reservation'
import report from './../report'

// ** Merge & Export
export default [...dashboards, ...userAccount, ...reservation, ...report, ...parking, ...administration]